import { render } from "./Bottom.vue?vue&type=template&id=3f3ee56e&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=3f3ee56e&lang=css"
import "./Bottom.vue?vue&type=style&index=1&id=3f3ee56e&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\vue-argon-centrion\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3ee56e"]])

export default __exports__